import fetch from "auth/FetchInterceptor";

const ataDefinitionsService = {};

ataDefinitionsService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/ata-definitions",
		method: "get",
		params,
	});
};

ataDefinitionsService.post = function (data) {
	return fetch({
		url: "/v1/rest/ata-definitions",
		method: "post",
		data: data,
	});
};

ataDefinitionsService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/ata-definitions/${id}`,
		method: "put",
		data: data,
	});
};

ataDefinitionsService.getById = function (id) {
	return fetch({
		url: `/v1/rest/ata-definitions/${id}`,
		method: "get",
	});
};

ataDefinitionsService.del = function (id) {
	return fetch({
		url: `/v1/rest/ata-definitions/${id}`,
		method: "delete",
	});
};

export default ataDefinitionsService;
